import "./layout.css";
import "./react-table.grid.css";
import "./spinner.css";

import UnexpectedErrorStore from "../store/unexpected-error-store";
import AuthStore from "../store/auth-store";
import LoadingSpinner from "./spinner";
import SideMenu from "./menu/side-menu";
import { observer, inject } from "mobx-react";
import { Navigate } from "react-router";
import { Header } from "./header/header";
import { Footer } from "./footer";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { readUserSetting } from "./user-settings/web";
import UserSettingsStore, {
    DefaultUserSettings,
    SortFieldDesc,
    SortFieldValue,
    SortSettings,
    UserSettings,
} from "../store/user-settings";

export interface LayoutProps {
    children?: React.ReactNode;
    unexpectedErrorStore?: UnexpectedErrorStore;
    authStore?: AuthStore;
    userSettingsStore?: UserSettingsStore;
}
export interface ILayoutState {
    authenticating: boolean;
}

function Layout(props: LayoutProps) {
    const { authStore, userSettingsStore } = props;
    const { t } = useTranslation("common");
    const { isAuthenticated, isAuthenticating } = authStore!;

    useEffect(() => {
        const userSettingsKeys = Object.values(UserSettings);
        const sortSettingsKeys = Object.values(SortSettings);

        if (isAuthenticated) {
            readUserSetting().then((response: any) => {
                const userSettings = response.data.userSettings;

                //SORT SETTINGS
                sortSettingsKeys.map((key) => {
                    const id = userSettings[key + SortFieldValue];
                    const desc = userSettings[key + SortFieldDesc];

                    userSettingsStore!.initializeSortSetting(key, id, desc);
                });

                //USER SETTINGS
                userSettingsKeys.map((key) => {
                    const defaultValue = DefaultUserSettings[key];
                    let settingValue = userSettings[key];

                    if (typeof defaultValue === "boolean") {
                        settingValue = settingValue === "true";
                    } else if (typeof defaultValue === "number") {
                        settingValue = Number(settingValue);
                    }

                    userSettingsStore!.initializeSetting(key, settingValue);
                });
            });
        }
    }, [isAuthenticated]);

    const render = () => {
        const showSideMenu = window.self === window.top;

        if (isAuthenticating) {
            return <LoadingSpinner />;
        }
        if (isAuthenticated === false) {
            return <Navigate to="/login" />;
        }

        return (
            <div className={"layout"}>
                <Header t={t} />
                <div className="layout-content-container">
                    {showSideMenu && <SideMenu />}

                    <div id="main" className={"main"}>
                        <Outlet />
                    </div>
                </div>
                <Footer />

                <LoadingSpinner />
            </div>
        );
    };

    return render();
}

export default inject("authStore", "userSettingsStore")(observer(Layout));
